import { actions } from "./actions";

export { actions };

export default {
  namespaced: true,
  actions
};
